export enum LocalStorage {
  TASK = 'task',
  ASSIGNMENT = 'assignment',
  ROOM_LOCATION = 'ROOM_LOCATION',
  SETTINGS = 'settings',
}
